import { render, staticRenderFns } from "./calc06.vue?vue&type=template&id=521fdd8e"
import script from "./calc06.vue?vue&type=script&lang=js"
export * from "./calc06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports